import { ProductFamily } from './pdf-layout';
import {
  pricingMessageContainer,
  productFamilyNameText
} from './product-family-component.styles';
import { familyLogoWrapperStyle } from './product-row.styles';
import ProductRow from './product-row';
import AppRow from './app-row';
import { multiProductRowStyle, productRowStyle } from './pdf-layout.styles';
import { PricingPeriod } from '@atlassiansox/bxp-use-pricing';

type ProductFamilyComponentProps = {
  family: ProductFamily;
  billingCycle: PricingPeriod;
};

const ProductFamilyComponent = ({
  family,
  billingCycle
}: ProductFamilyComponentProps) => {
  const shouldDisplayFamilyRow =
    family.selectedProducts && family.selectedProducts.length > 1;

  const sortedProducts = [...(family.selectedProducts || [])].sort((a, b) =>
    a.name.localeCompare(b.name)
  );
  const sortedApps = [...(family.apps || [])].sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  return (
    <div css={shouldDisplayFamilyRow ? multiProductRowStyle : productRowStyle}>
      {shouldDisplayFamilyRow && (
        <div className="pdf-row">
          <div className="col col1">
            <div css={familyLogoWrapperStyle}>{family.logo}</div>
            <div css={productFamilyNameText}>{family.familyName}</div>
          </div>
        </div>
      )}
      {sortedProducts.map((product, index) => (
        <ProductRow
          key={product.name + index}
          product={product}
          shouldDisplayFamilyRow={shouldDisplayFamilyRow}
          family={family}
          billingCycle={billingCycle}
        />
      ))}
      {sortedApps.map((app, index) => (
        <AppRow key={app.name + index} app={app} billingCycle={billingCycle} />
      ))}
      {family.billingMessage && (
        <div css={pricingMessageContainer}>{family.billingMessage}</div>
      )}
    </div>
  );
};

export default ProductFamilyComponent;
